module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("4"), _c('br'), _vm._v("Into the Night")])])]), _c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Isobel craned her neck inside her room, surprised to find her friend reclined in the middle of the full-size bed, her back propped against the cubbyhole headboard, supported by a stack of pillows. In one hand, Gwen held a folded-over magazine; her entire head was obscured behind the glossy image of a pouting, airbrushed Maybelline model. Her skinny legs lay stretched out in front of her, her blue-and-white-striped stockinged feet wagging beneath the hem of a long, bluish-green broom skirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel couldn’t help but smile. Even in the middle of winter it seemed as though Gwen was unwilling to forgo her usual skirt-over-spandex-leggings look for a more practical (not to mention warmer) pair of jeans or corduroys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over one shoulder, Gwen’s forever long and straight mouse-brown hair lay draped in a ropelike braid. Her free hand rummaged through Isobel’s emergency stash bag of chocolate-covered pretzels. Seemingly oblivious to Isobel’s presence, Gwen continued to graze, the sound of crunching issuing loudly from behind the magazine.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Helloooo,”")]), _vm._v(" Isobel said as she slipped inside. She paused, glancing first left and then right, still trying to determine the ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("source of the shadow she thought she had seen only a moment before. Confused, she shut her bedroom door behind her. It clicked quietly into place, but Gwen still didn’t look up. Isobel frowned. She set the shopping bags down, approached her bed, and placed one hand on the magazine to lower it.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen’s attention snapped upward. She froze in mid-chew, brows arched in surprise. She blinked chestnut eyes at Isobel from behind her oval-framed glasses until recognition settled in. Then, the tension in her frame easing, she dropped the magazine to her lap, swallowed, and plucked free a pair of white earbuds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Home at last,” she quipped in her dry Brooklyn accent. “If I’d known they were letting you out of the house, I’d have brought along a book. Honestly, how do you read this schlock?” Gwen gestured to the magazine in her lap. “I mean, who cares if it’s better to wax your eyebrows or tweeze them? As long as you’re not shaving them off and drawing them back on in brown Sharpie like my aunt Clarice. By the way, next time do me a favor and warn me when there’s going to be a cover charge, would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel winced. “Sorry about that. Listen, I’ll pay you back.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Gwen waved her off, her array of thin metal bracelets clinking like chimes. “Eh, I’d settle for giving your brother a swirly.” With nimble fingers, she wound her earbud cord around her lime-green iPod before stuffing them into the hand-sewn patchwork purse at her side. “Believe me,” she added, palm raised, “normally, I’m the kind of person who prefers the nontactile approach when it comes to retribution, ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("but if you decide you want to dunk your brother’s head in the toilet and you need help, I won’t think that’s asking too much. As long as you’re the one doing the heavy lifting, I think I can manage to press the flush.”")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel grinned in spite of herself. She had not seen Gwen since school had let out for Christmas break the previous week. Even before that, with practice every day because of Nationals, they’d only been able to talk briefly between class breaks, at lunch, and over Facebook. But with Isobel’s dad still griping over Gwen’s involvement in Halloween night, they’d both agreed to lie low on phone calls and texting. Especially with Isobel’s dad checking her cell like a nurse with a heart monitor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see you found my pretzels,” Isobel said. She tossed her own purse onto the bed next to Gwen’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen sat up. She brushed her hands off, dusting Isobel’s pink bedspread with crumbs. “They called to me from your top dresser drawer. What can I say? I got a case of the munchies from smelling whatever it is your mom’s cooking down there,” she prattled on. “And there was no telling how long you were gonna be gone, so what was I supposed to do? Starve myself? They’re a little stale, though—Whoa!” Gwen halted, her eyes bugging. Without warning, she swiped at Isobel, snatching her hand and bringing it to her nose. “Talk about bling,” she said, eyeing Isobel’s championship ring. “That where you’ve been all this time? Deep-sea diving with the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Titanic")]), _vm._v(" wreckage?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Isobel pried her hand gently from Gwen’s. Shrugging, ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("she tucked a stray lock of hair behind her ear, then turned and sank down on the edge of her bed next to Gwen. She stuffed both hands between her knees to hide the ring from view. “Coach’s idea,” she said. “The squad voted on ordering them, since this was our third win in a row. I wasn’t going to get one, but when Dad found out about it, he insisted.”")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen grunted. Leaning back again, she folded her arms behind her head and crossed her bony legs at the ankles. “How "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" the warden anyway? That who you’ve been out with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Last-minute Christmas shopping,” Isobel said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen perked up at the word “shopping.” Seeming to notice the small cluster of bags for the first time, she all but catapulted off the bed. “You shouldn’t have,” she said, situating herself in a cross-legged position on Isobel’s rose-colored carpeting, hiking up her skirt and exposing the dark-brown stirrup leggings beneath. She dipped an arm into a gold bag accented with green and red holly designs. “Especially since I’m Jewish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel smiled. “That one’s for Dad,” she said, watching as Gwen removed and shook a sleek rectangular box wrapped in green-and-gold paper. The object inside thudded heavily against the cardboard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me guess,” Gwen said. “Padlock to add to his collection?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel rolled her eyes. “Cologne.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s hope it helps,” Gwen muttered, and went back to foraging, the tissue paper rustling noisily as she retrieved a small, flat parcel wrapped in glittery red.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("“Ooh,” she said, plucking at the gauzy green bow. “This one looks fancy.” She weighed the box in one hand, then lifted it to her ear, giving it a shake. A quiet whispering sound came from within. “Tennis bracelet?” she guessed.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Close. Snowflake locket. Dad’s gift to Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Humph.” Gwen placed the box on the floor next to the other. “What else you got in here?” she asked over the crinkling of bags.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel glanced away, her attention caught by the popcorn-size flecks of white collecting on the sill outside her window. Pushing off from the bed, she went to open her lace curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jeez,” she murmured, “it’s really starting to come down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? That?” Gwen scoffed. “That’s cotton candy snow. All fluff and empty calories. It’ll be gone first thing in the morning, just wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Staring at the roof ledge, Isobel zeroed in on one of the tiles near the middle of the downward slope, one with an upturned edge, curled like a beckoning finger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It made her think of that night Varen had climbed onto her roof. In his effort to make a peace offering in the form of cooler-packed cartons of ice cream, he’d somehow lost his footing. Isobel recalled her sense of utter helplessness as she’d watched him sail backward, nearly shooting straight over the edge, only to catch himself at the last second.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been the one and only time she’d ever seen him falter.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Before that night, he’d always been so sure-footed, so controlled. Not only in his movements and stride, but in his manners and words, too. Every syllable he spoke had a ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("purpose. Every pointed glance held a hidden meaning or an underlying message. It was as if he had his own secret language, one she’d only just begun to understand.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, what’s this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?” Isobel turned just in time to see Gwen pull free a long brown-and-cream-colored scarf from a mint-green bag made from recycled paper. A pair of fingerless gloves, crocheted from the same material as the scarf and accented with two woolly, wide-eyed owls, dangled from one end, attached by a tag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh,” Isobel said. “Those are for you. I know it’s a little belated, but happy Hanukkah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me")]), _vm._v("?” Grinning, Gwen ducked her head to loop the scarf around her neck. Next, she tugged on the gloves, fingers flexing. “I love the owls. Oh, and they’re warm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tilted her chin up and tossed the end of her new scarf over one shoulder, fighter-pilot-style. After that, she grabbed the remaining bags and relocated to Isobel’s bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me guess,” Gwen said as she drew out Isobel’s still unwrapped gift to Danny—a pair of heavy-duty black headphones accented with green skull designs. “These are for the little gonif, am I right? I don’t think it’s unfair to assume that I’m a shareholder in these, do you? I vote we let him try them on, plug them in, and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("then")]), _vm._v(" we do the swirly.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("“I just hope he wears them,” Isobel muttered, returning her attention to the window. “So I don’t have to listen to that video-game garbage anymore. Since school’s been out, he’s been staying up all night playing on his computer. I can’t ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("sleep.” Her focus switched from the cascade of falling snow to her image reflected in the darkened glass. Arms crossed, she studied the outline of her straight blond hair and wan features. Her gaze lingered on the faint dark half-circles etched beneath each eye.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For a moment, it was as though she couldn’t place her own face. A stranger, too thin and too pale, stared back at her, withered-looking, like a plant in need of sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Behind her, the rustling of bags and papers ceased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you and I both know that’s not the real reason,” Gwen said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel’s gaze shifted from her own reflection to Gwen’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A beat of silence radiated between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again Isobel smiled, but it was the rueful kind this time. She knew this was Gwen’s way of ending the easy banter, of cutting to the chase and getting down to the real reason she’d come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her arms still folded, Isobel turned to face Gwen, though without meeting her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a moment, she contemplated telling Gwen about last night’s dream. She stopped herself short, however, reeling in the urge to do so as soon as she opened her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was something still so vaporous about the vision. As if it might dissolve the second she tried to put the experience into actual words. That, and she wanted to keep on believing that it had been real. If she told someone else, even if that someone happened to be her best friend, would she then run the risk of having all her doubts confirmed?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("“No,” Isobel said at last. “I guess it’s not.”")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen swiveled where she sat to face Isobel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the verdict on Baltimore, anyway?” she asked. “Are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And just like that, playtime was over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel drew in a shuddering breath. “Dad says no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen’s mouth twitched at one corner, as though she wasn’t certain how to react. At the very least, Isobel’s answer hadn’t seemed to surprise her. “Did you use the excuse of going to look at a school like I told you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And that didn’t work?” Gwen leaned back, looking stumped. “Sheeze. You’d think your parents would throw a parade.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel shot her a glare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I mean . . . you’d be cheering for a university squad!” Gwen waggled her fists as though she held a pair of invisible pom-poms. “I hear the trophies get bigger in college?” she said, her voice turning up at the end like she couldn’t be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This time, Isobel didn’t smile. Her mood for joking had dissipated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll just have to find another way,” she said, crossing to kneel beside the bags Gwen had left on the floor. One at a time, she repacked the presents.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("“Isobel . . . ,” Gwen began. She took a long time before continuing, which made Isobel worry, since filtering wasn’t one of Gwen’s regular talents. “I’ve been doing a lot of thinking,” she said at last. “And in all honesty, how can you ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("be sure this Poe Toaster guy is even going to show up this year?”")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel scowled. “He "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("has")]), _vm._v(" to show up,” she snapped. “The article says that the Toaster comes every single year. What would make this year any different?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the corner of her vision, Isobel marked Gwen’s measured and slow approach. She kept her eyes downcast, even as the hem of Gwen’s skirt and the toes of her striped socks stopped within a foot of where Isobel knelt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The article also says that nobody knows how this guy gets into the graveyard,” Gwen said. “Or out, for that matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I don’t understand,” Gwen went on, “is what happens once you’re there. Let’s say, for instance, that we actually get you to Baltimore. Then you manage to sneak into the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("locked")]), _vm._v(" graveyard without getting arrested for trespassing, grabbed off the street, shoved into a van, or shot. Next, this guy shows up, and then what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He knows where Varen is. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("That’s")]), _vm._v(" what. What else is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There came the sharp clank of bracelets as Gwen lowered herself to kneel beside Isobel. “So . . . are you saying that you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("don’t")]), _vm._v(" know where he is?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel stopped repacking the presents, able to feel Gwen’s searching gaze.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Up until this point, she had managed to dodge Gwen’s gentle prods concerning the details of that night. And for her part, Gwen had refrained from asking "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("too")]), _vm._v(" much during the short spurts of time in which they’d seen each other at ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("school. Isobel had no doubt that Gwen’s effort to restrain herself from bombarding her with questions must have been nothing short of agonizing. And Isobel could now sense that the time for evasion, along with Gwen’s patience, had reached its end.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("ever")]), _vm._v(" going to tell me what happened that night?” Gwen asked. “What "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("really")]), _vm._v(" happened? If you’re going to do this, Isobel, if you’re going to go to Baltimore, then you’re going to need help. And you’re going to need a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("plan")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel already knew that Gwen was right. As much as she wanted to think otherwise, she doubted she could do it all alone. Cornered at last, she looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s so much. I barely understand it myself. I don’t even know where to start.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The beginning is good,” Gwen prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The beginning?")]), _vm._v(" Isobel wanted to laugh, mostly because it sounded so logical. But there was nothing logical about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel thought about the day she and Varen had first met, that day when Mr. Swanson had paired them together for the project. She remembered the way Varen had looked, sitting slouched in his chair, all darkness and quiet brooding, his black book pinned between his arm and the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It all started because of his writing,” Isobel murmured, aware that this was the first time she’d divulged this to anyone. “He was writing about . . . another world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another world?” Gwen made a face, as though the words didn’t taste right in her mouth.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("But Gwen had seen Reynolds fight that night at the Grim ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("Facade after all, had known that his opponent, the specter swathed in crimson robes, awash in blood, had not been an illusion. She had known, too, unlike the rest of those in attendance, that the battle with the Red Death had not been a staged performance.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it . . . safe to assume that that’s where Varen is now? In this other world?” she asked, each word like a timid step into a pitch-black room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel nodded slowly, relieved to have Gwen connect the dots on her own. It helped not having to put things into words herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Words.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hadn’t Reynolds once warned her about the power of words? What had he said? That they could conjure, that they could bring things into being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Before any of it started,” Isobel said, taking in a gulp of air, “before everything unraveled, before I started to see things, to hear things, Varen was writing. Remember that black sketchbook he always carried with him? It all had something to do with Poe. I think that’s why Varen chose him for the project. He was reading Poe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you ever read any of what Varen wrote?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel nodded. “Once. And . . . again. Later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel shook her head. “He was always writing about the same thing,” she whispered. “About a woman. She came to him in his dreams, appearing every night. Calling to him for . . . something.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("“You mean it was like a dream journal?” Gwen asked, eyes narrowing.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Isobel murmured, then corrected herself. “It was a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("kind")]), _vm._v(" of dream journal. But it was also a story. She . . . this woman, she wanted him to write. It . . . I think it gave her power.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you still have it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Varen’s journal?” Isobel shook her head once more. “No. I burned it. I had to. It was the only way to . . . to close the link.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Link?” Gwen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Varen created a link with the story he wrote,” Isobel explained, “between this world and . . . and a dreamworld. But then everything started to leak together. That’s what happened at the Grim Facade. Then, when I destroyed the journal, I broke the link. I only did it because I thought Varen was here. Back in "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("this")]), _vm._v(" world. Safe. I thought he had come back. But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen eyed her with uncertainty. Up until this moment, she had been eager to learn about the details of that night, the strange and seemingly unexplainable events that had led to Varen’s vanishing. Now, though, with her upper lip crimped into a squiggly line of unease, she looked as though she couldn’t be sure of what Isobel was telling her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gwen, I know you must think that I’m crazy, that I’m making this up, but I was there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was there too, remember?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("“No, Gwen. I mean, I was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("there")]), _vm._v(". On the other side. In the ")]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("dreamworld. I went looking for him there. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("That’s")]), _vm._v(" where I went when you couldn’t find me.”")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen frowned, her eyes darting to one side. “About this woman,” she began. “The one you said Varen was writing about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel could sense Gwen’s growing apprehension. She felt nervous tension radiating from her friend’s tiny frame, as palpable as an electric current.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel kept her eyes steady on Gwen, waiting, finally ready for whatever she might ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did she look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The simplicity of the question surprised Isobel. She thought about it for a moment, once again envisioning the woman who had appeared to her in the inverted dream version of the bookstore attic, luminous in swaths of white gossamer and tumbling veils. “She was . . . well, she was beautiful,” she admitted. “And at first, that’s all I could think when I saw her. She had white skin, like marble. And long, thick black hair. Tons of it.” As she spoke, Isobel traced her fingers through the air around her own hair, her hands gliding down past her shoulders and, before she knew it, all the way to the floor. “She wore layers of white veils that wound down to her feet. And her eyes . . .” Isobel shook her head. She would never in her life forget those eyes. “They were black. Completely black.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("She glanced up, realizing that she’d been lost in thought. She focused on the distraught expression that her friend now wore. It was so unfamiliar to her that Isobel had to ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("backtrack mentally through her words, wondering what she had said that Gwen had found so disturbing. Then again, hadn’t Gwen already witnessed the worst for herself at the Grim Facade? Like Pinfeathers and the Nocs—those hollow demons, shape-shifting monsters with shattered faces and razor claws, that had followed Isobel from their world to this one.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe, Isobel reasoned, Gwen was still trying to wrap her head around the concept of there being another dimension. Though, given everything that had happened, Isobel knew there weren’t too many other conclusions left for Gwen to draw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did she tell you her name?” Gwen asked, her words slow, her voice laden with such dead seriousness that it made Isobel pause before answering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Varen called her Bess, I think,” Isobel said, still trying to gauge the source of Gwen’s sudden trepidation. “But then, when I asked her, she said her name was Ligeia, which was weird because I knew that was a character from one of Poe’s stories. Then she said that she had many names. She called herself—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Lilith,”")]), _vm._v(" Gwen whispered, her face white.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel’s mouth popped open in shock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quickly Gwen stood. Dashing to the bed, she snatched up her purse and coat. Then, stooping to gather her shoes, she stuffed everything under one arm, opened Isobel’s door, and darted out into the hall.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("“Gwen!” Isobel leaped to her feet. She rushed out of ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("her room, only to find her friend already halfway down the stairs. She resisted the urge to call out, not wanting to alert her parents, who were still in the kitchen, and barreled after her.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen did not pause when she reached the foyer. Opening the front door, she shoved her way through the outer storm door and vanished into the darkness with a swirl of skirts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel caught the storm door just as it latched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she rasped, and fumbled to turn the handle. Outside, she could see Gwen hurrying through the winter bluster toward the old 1990s navy-blue Cadillac parked across the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Managing at last to twist the handle, Isobel pushed the door open. She stumbled into the cold, down from the porch and through the darkened yard, only realizing she didn’t have shoes on when the snow soaked through the thin layer of her socks. She ran despite the bitter sting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gwen!” she shouted, no longer caring who heard. “Stop!” Her voice echoed, reverberating through her silent, still neighborhood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ahead of her, Gwen faltered, tripping over the now snow-caked hem of her skirt before colliding with the driver’s-side door of the Cadillac.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel heard the jangle of car keys. She ran faster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gwen!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t talk to you!” Gwen shouted, whirling to face Isobel, who skittered to a halt. “Ever again.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Isobel gaped at her. Gwen, in turn, swiveled away and, ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("pulling the car door open, sank inside the Cadillac, shoving her things into the vacant passenger seat.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel forced herself to move and caught the door before Gwen could pull it shut. “Why are you doing this?” she demanded. “How did you know—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gwen put her key into the ignition and twisted it. The Cadillac rumbled to life, cutting Isobel off. Its headlights sprang on, illuminating the curtain of cascading snow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May God protect you,” was Gwen’s only answer before she tugged the door free from Isobel’s grip. It slammed shut with an echoing clap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait!” Isobel shouted, staring into the driver’s-side window through her own distraught reflection at Gwen as she shifted the car into gear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Open the door!” Isobel slammed her palm against the glass. “Gwen, if you know something, you have to tell me! "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Gwen!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel heard the engine rev. The rear tires spun before gaining traction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t just leave like this!” Isobel screamed. She latched onto the handle of the driver’s-side door and pulled, only to find it locked. “Gwen! You’re the only one I have. You’re the only one who knows the truth! Please!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The car lumbered forward, snow groaning as it compressed beneath the tires, the frozen handle tearing free from Isobel’s grip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gwen!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Whining, the Cadillac gave a grating screech as it swung ")]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("around her in a wide arc. Isobel turned where she stood, her hair whipping in her face as the car sped past her with a guttural growl, its headlights slashing through the darkness.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The crimson taillights flared. Isobel stared after them as Gwen swerved, fishtailing around the stop sign at the end of the street and speeding out of sight.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c16ef8f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 81
// module chunks = 0